import { render, staticRenderFns } from "./SendMessageWithTemplateForm.vue?vue&type=template&id=3f86d376&scoped=true&"
import script from "./SendMessageWithTemplateForm.vue?vue&type=script&lang=js&"
export * from "./SendMessageWithTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageWithTemplateForm.vue?vue&type=style&index=0&id=3f86d376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86d376",
  null
  
)

/* custom blocks */
import block0 from "./SendMessageWithTemplateForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./SendMessageWithTemplateForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextarea})
